import { useMemo, useRef } from "react";
import { hydrateAllAccountsInboxFromSession } from "@/lib/mail/inboxHeadersSessionHydrate";
import type { MailAccountSummary } from "@/lib/types/mail";

/**
 * Hydrate INBOX depuis localStorage → bus **pendant le render** (avant useInboxMessages).
 * useLayoutEffect arrive trop tard : initialSnap du hook liste est déjà null.
 */
export function useInboxHeadersSessionHydrate(
  accounts: MailAccountSummary[],
  options?: { enabled?: boolean }
): void {
  const enabled = options?.enabled !== false;
  const accountIds = useMemo(
    () => accounts.map((a) => a.id).sort((a, b) => a - b).join(","),
    [accounts]
  );
  const hydratedKeyRef = useRef("");

  if (enabled && accounts.length > 0 && hydratedKeyRef.current !== accountIds) {
    hydrateAllAccountsInboxFromSession(accounts.map((a) => a.id));
    hydratedKeyRef.current = accountIds;
  }
}
